import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, ButtonGroup } from 'react-bootstrap';

export class ToggleButtonGroup extends React.Component {
  clickHandlerLeft = () => {
    this.props.handleClickEvent(this.props.leftLabel.defaultMessage);
  }

  clickHandlerRight = () => {
    this.props.handleClickEvent(this.props.rightLabel.defaultMessage);
  }

  render() {
    const selectedToggle = (this.props.currentSelection === this.props.leftLabel.defaultMessage) ? 'left' : 'right'

    return (
      <div className={`form-group col-md-3 col-xs-6 ${this.props.className}`}>
        <div id="date-filter-input-group" className="btn-group btn-group-justified" role="group" data-toggle="buttons">
          <ButtonGroup>
            <Button
              variant="outline-secondary"
              className={'btn btn-default' + (selectedToggle === 'left' ? ' active' : '')}
              style={{ color: 'var(--bs-btn-border-color)' }}
              onClick={this.clickHandlerLeft}
              value={this.props.leftLabel.defaultMessage}
            >
              <FormattedMessage {...this.props.leftLabel } />
            </Button>
          </ButtonGroup>

          <ButtonGroup>
            <Button
              variant="outline-secondary"
              className={'btn btn-default' + (selectedToggle === 'right' ? ' active' : '')}
              style={{ color: 'var(--bs-btn-border-color)' }}
              onClick={this.clickHandlerRight}
              value={this.props.rightLabel.defaultMessage}
            >
              <FormattedMessage {...this.props.rightLabel } />
            </Button>
          </ButtonGroup>
        </div>
      </div>
    );
  }
}

ToggleButtonGroup.propTypes = {
  leftLabel: PropTypes.object,
  rightLabel: PropTypes.object,
  handleClickEvent: PropTypes.func,
  currentSelection: PropTypes.string,
};
